import { EMOJI_CATEGORY } from "@/src/shared/emoji/constants";
import type { EmojiCategory } from "@/src/shared/emoji/types";

interface EmojiPickerCategory {
  id: EmojiCategory;
  native?: string;
}

export const EMOJI_PICKER_CATEGORIES: readonly EmojiPickerCategory[] = [
  { id: EMOJI_CATEGORY.Recent, native: "🕣" },
  { id: EMOJI_CATEGORY.SmilesAndPeople, native: "😀" },
  { id: EMOJI_CATEGORY.AnimalsAndNature, native: "🐶" },
  { id: EMOJI_CATEGORY.FoodAndDrink, native: "🍎" },
  { id: EMOJI_CATEGORY.Activities, native: "⚽" },
  { id: EMOJI_CATEGORY.TravelAndPlaces, native: "🚗" },
  { id: EMOJI_CATEGORY.Objects, native: "💡" },
  { id: EMOJI_CATEGORY.Symbols, native: "🩷" },
  { id: EMOJI_CATEGORY.Flags, native: "🚩" },
  { id: EMOJI_CATEGORY.All },
];
